import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Scale, ArrowRight } from 'lucide-react';
import { useUser } from '../context/UserContext';
import { FEATURES } from '../lib/featureFlags';

export default function CompareFAB() {
    const { compareList } = useUser();
    const location = useLocation();

    // Hidden globally while FEATURES.SHOW_COMPARE is false.
    if (!FEATURES.SHOW_COMPARE) return null;

    // Don't show if list is empty or currently ON the compare page
    if (compareList.length === 0 || location.pathname === '/compare') return null;

    return (
        <Link
            to="/compare"
            className="fixed bottom-8 right-8 z-50 animate-bounce-in"
        >
            <div className="relative group">
                {/* Badge Count */}
                <div className="absolute -top-2 -right-2 w-6 h-6 bg-red-500 text-white text-xs font-bold rounded-full flex items-center justify-center border-2 border-white shadow-sm z-10 animate-scale-in">
                    {compareList.length}
                </div>

                {/* Main Button */}
                <div className="flex items-center gap-3 pl-5 pr-4 py-3 bg-slate-900 text-white rounded-full shadow-2xl hover:scale-105 hover:bg-black transition-all duration-300 border border-white/10">
                    <div className="flex flex-col items-start pr-2 border-r border-white/20">
                        <span className="text-[10px] uppercase font-bold text-slate-400 tracking-wider">Compare</span>
                        <span className="text-sm font-bold leading-none">{compareList.length} College{compareList.length > 1 ? 's' : ''}</span>
                    </div>
                    <Scale className="w-5 h-5 text-amber-400 group-hover:rotate-12 transition-transform" />
                </div>

                {/* Glow Effect */}
                <div className="absolute inset-0 bg-blue-500/20 rounded-full blur-xl -z-10 group-hover:bg-blue-500/40 transition-all duration-500"></div>
            </div>
        </Link>
    );
}
